import React, { useEffect, useState } from "react";
import axios from "axios";
import { FaRegCalendarAlt } from "react-icons/fa";
import { NavLink, useParams } from "react-router-dom"; // Import useParams

const apiUrl = process.env.REACT_APP_BACKEND_URL;

const Gallery = () => {
  const [data, setData] = useState([]);
  const [showAll, setShowAll] = useState(false);

  useEffect(() => {
    axios
      .get(`${apiUrl}/api/v1/getgallery`)
      .then((response) => {
        const fetchedData = response.data.data || [];

        // Sort the data in descending order based on date
        const sortedData = fetchedData.sort(
          (a, b) => new Date(b.date) - new Date(a.date)
        );
        setData(sortedData); // Update the state with sorted data
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  // Function to handle click on "View All" button
  const handleViewAll = () => {
    setShowAll(true); // Set showAll to true to display all images
  };

  const handleCloseAll = () => {
    setShowAll(false); // Set showAll to false to display all images
  };

  const formatDateTime = (dateTime) => {
    const date = new Date(dateTime);
    return {
      date: date.toLocaleDateString(),
    };
  };

  return (
    <>
      <div className="bg-[#343694] py-[20px] px-[10px] mx-[10px] mb-[20px] font-poppins my-[10px]">
        <h1 className="text-center text-white underline mb-[25px]"> Gallery</h1>
        <div className="grid gap-4 grid-cols-4 md:grid-cols-2 sm:grid-cols-1 pb-[10px] ">
          {data.map((gallery, index) => {
            const { date } = formatDateTime(gallery.date);
            return (
              <div
                style={{
                  display: showAll ? "block" : index < 8 ? "block" : "none",
                }}
                key={index}
              >
                <div className="hover:border-blue-gray-200 hover:shadow-md hover:shadow-blue-gray-200 hover:duration-1000 pb-[1px]">
                  {/* Use NavLink to navigate with the gallery ID */}
                  <NavLink to={`/photoGallery/Images/${gallery.id}`} className="no-underline">
                    {gallery.imageUrls && gallery.imageUrls.length > 0 ? (
                      <img
                        src={gallery.imageUrls[0]}
                        alt="Gallery Item"
                        className="w-full h-48 object-cover rounded-md"
                      />
                    ) : (
                      <p className="text-center text-gray-500">No Image Available</p>
                    )}
                  </NavLink>
                  <div className="text-white text-center mt-[10px] gap-0 ">
                    <p className="flex gap-[10px] justify-center items-center">
                      <FaRegCalendarAlt /> {date}
                    </p>
                    <p className="mt-[-13px]">{gallery.description}</p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
        {/* button for the images */}
        <div className="flex justify-center">
          {!showAll ? (
            <button
              onClick={handleViewAll}
              className="bg-orange-900 text-[20px] font-semibold text-white py-[5px] px-[20px] rounded-[10px] hover:bg-orange-700 duration-1000 hover:duration-1000"
            >
              View all Gallery
            </button>
          ) : (
            <button
              onClick={handleCloseAll}
              className="bg-orange-900 text-[20px] font-semibold text-white py-[5px] px-[20px] rounded-[10px] hover:bg-orange-700 duration-1000 hover:duration-1000 "
            >
              Close Gallery
            </button>
          )}
        </div>
      </div>
    </>
  );
};

export default Gallery;
